import "core-js/modules/es.array.push.js";
import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, toHandlers as _toHandlers, mergeProps as _mergeProps, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "admin-layout-wrapper"
};
const _hoisted_2 = {
  class: "left-menu-wrapper main-menu-wrapper"
};
const _hoisted_3 = {
  class: "left-menu-head"
};
const _hoisted_4 = {
  class: "menu-items-wrapper"
};
const _hoisted_5 = {
  class: "menu-list"
};
const _hoisted_6 = {
  class: "header-content-wrapper"
};
const _hoisted_7 = {
  class: "header-title"
};
const _hoisted_8 = {
  class: "header-extra-wrapper"
};
const _hoisted_9 = {
  class: "header-extra"
};
const _hoisted_10 = {
  class: "page-content-wrapper"
};
const _hoisted_11 = {
  class: "page-footer-wrapper"
};
import { computed, provide, reactive, ref } from 'vue';
import { MgHistoryRouteTabs, MgAuthorMenu, modal } from '@/share/components';
import { useRouter, useRoute } from 'vue-router';
import { useAuthorStore, useMyOrgStore, useUserRouterStore } from '@/stores';
import { useChangeSelfPwdModal } from '@/share/hooks/common';

import { watch, toRaw } from 'vue';
export default {
  __name: 'admin-layout',
  props: {
    title: {
      type: String,
      default: '码格数据采集系统'
    },
    homeTab: {
      type: Object,
      default: () => ({
        showHome: true,
        homePath: '/',
        homeTitle: '首页'
      })
    },
    winTabBarProps: {
      type: Object,
      default: () => ({})
    },
    historyRouteStoreKey: {
      type: String,
      required: true,
      default: ''
    },
    // 窗口标签选项卡本地存储键名
    menus: {
      type: Array,
      default: () => []
    },
    authorMenu: {
      type: Array,
      default: () => []
    },
    wins: {
      type: Array,
      default: () => []
    },
    showFooter: {
      type: Boolean,
      default: false
    },
    pageHeaderClass: {
      type: String,
      default: 'admin-header'
    },
    pageClass: {
      type: String,
      default: ''
    },
    appGroup: {
      type: String,
      default: 'default'
    },
    methods: {
      type: Object,
      default: () => ({})
    },
    excludeAlive: {
      type: Array,
      default: () => []
    }
  },
  emits: ['menuClick', 'leftExpanded', 'winTabMenuClick', 'refreshClick', 'closeWinClick', 'winTabChanged', 'winTabClose', 'authorMenuClick', 'authorAvatarClick', 'refreshMenu'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const router = useRouter();
    const route = useRoute();
    const userRouterStore = useUserRouterStore();
    const authorStore = useAuthorStore();
    const myOrgStore = useMyOrgStore();
    const currentPageRef = ref();
    const {
      showChangeSelfPwdModal
    } = useChangeSelfPwdModal();
    const leftSplitOptions = reactive({
      padding: false,
      border: false,
      barConfig: {
        width: '8px'
      }
    });
    const leftSideConfig = reactive({
      enabled: true,
      showPrevButton: true,
      showNextButton: false
    });
    const emit = __emit;
    const props = __props;
    const adminMenus = ref([]);
    watch(() => props.menus, val => {
      adminMenus.value = [...toRaw(val)];
    }, {
      immediate: true,
      deep: true
    });
    const selectMenuItem = ref();
    const historyTabsOptions = computed(() => {
      return {
        ...props.winTabBarProps,
        ...props.homeTab
      };
    });
    const handleTabBarRefreshData = () => {
      const $currentPage = currentPageRef.value;
      if (!$currentPage || typeof $currentPage.refresh !== 'function') return;
      $currentPage.refresh();
    };
    const historyTabsEventHandlers = {
      refreshDataClick: handleTabBarRefreshData
    };
    async function quitSystem() {
      const cfm = await modal.confirm('退出确认', '您确认要退出系统吗？');
      if (!cfm) return Promise.resolve(false);
      authorStore.$reset();
      myOrgStore.$reset();
      systemIDE.resetHistory();
      userRouterStore.setRouterIsReady(false);
      return router.push({
        path: '/login'
      });
    }
    const handleMenuClick = ({
      menu,
      $event
    }) => {
      const {
        action,
        name,
        href,
        target = '_self'
      } = menu;
      if (!action && !name && !href) return;
      if (href) {
        const link = router.resolve({
          path: href
        });
        window.open(link.href, target || '_self');
        return;
      }
      switch (name) {
        case 'quit':
          quitSystem();
          break;
        case 'changeSelfPwd':
          showChangeSelfPwdModal();
          break;
      }
      if (typeof action === 'string') {
        switch (action) {
          case 'change-password':
            showChangeSelfPwdModal();
            break;
          case 'sign-out':
            quitSystem();
            break;
          default:
            console.debug('Unknown menu action:', action);
        }
      } else if (typeof action === 'object') {
        router.push(action);
      } else if (typeof action === 'function') {
        action(systemIDE);
      }
      emit('menuClick', {
        menu,
        $event
      });
    };
    const handleAuthorMenuClick = ({
      item,
      user,
      $event
    }) => {
      const {
        name
      } = item || {};
      switch (name) {
        case 'quit':
          quitSystem();
          break;
        case 'changeSelfPwd':
          showChangeSelfPwdModal();
          break;
      }
      emit('authorMenuClick', {
        item,
        user,
        $event
      });
    };
    const handleAuthorAvatarClick = ({
      user,
      $event
    }) => {
      emit('authorAvatarClick', {
        user,
        $event
      });
    };
    const splitEvents = {
      'toggleExpand'({
        expanded,
        item
      }) {
        emit('leftExpanded', {
          expanded,
          item
        });
      }
    };
    const historyRouteTabsRef = ref();
    const systemIDE = reactive({
      'quit'() {
        quitSystem();
      },
      'resetHistory'() {
        !!historyRouteTabsRef.value && historyRouteTabsRef.value.resetHistory();
      },
      'changeSelfPwd'() {
        showChangeSelfPwdModal();
      },
      'emitRefreshMenu'() {
        emit('refreshMenu');
      },
      getCurrentPage() {
        return currentPageRef.value;
      },
      historyRouteBar: {
        'closeCurrent'() {
          const $historyBar = historyRouteTabsRef.value;
          !!$historyBar && $historyBar.closeCurrent();
        },
        'closeOther'() {
          const $historyBar = historyRouteTabsRef.value;
          !!$historyBar && $historyBar.closeOther();
        },
        'closeAll'() {
          const $historyBar = historyRouteTabsRef.value;
          !!$historyBar && $historyBar.closeAll();
        },
        'getHistoryRoutes'() {
          const $historyBar = historyRouteTabsRef.value;
          return !!$historyBar && $historyBar.getHistoryRoutes();
        },
        'setCurrentTabTitle'(title) {
          const $historyBar = historyRouteTabsRef.value;
          !!$historyBar && $historyBar.setCurrentTabTitle(title);
        },
        'setTabTitle'(oRoute, title) {
          const $historyBar = historyRouteTabsRef.value;
          !!$historyBar && $historyBar.setTabTitle(oRoute, title);
        }
      }
    });
    provide('$systemIDE', systemIDE);
    __expose(systemIDE);
    watch(() => props.methods, val => {
      Object.assign(systemIDE, val);
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_vxe_menu = _resolveComponent("vxe-menu");
      const _component_vxe_split_pane = _resolveComponent("vxe-split-pane");
      const _component_vxe_layout_header = _resolveComponent("vxe-layout-header");
      const _component_router_view = _resolveComponent("router-view");
      const _component_vxe_layout_body = _resolveComponent("vxe-layout-body");
      const _component_vxe_layout_container = _resolveComponent("vxe-layout-container");
      const _component_vxe_split = _resolveComponent("vxe-split");
      const _component_vxe_layout_footer = _resolveComponent("vxe-layout-footer");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_vxe_layout_container, {
        vertical: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_vxe_layout_body, null, {
          default: _withCtx(() => [_createVNode(_component_vxe_split, _mergeProps({
            height: "100%",
            "action-config": leftSideConfig
          }, leftSplitOptions, _toHandlers(splitEvents)), {
            default: _withCtx(() => [_createVNode(_component_vxe_split_pane, {
              width: "200px"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_renderSlot(_ctx.$slots, "menu-header", {}, () => [_cache[1] || (_cache[1] = _createTextVNode("功能菜单", -1))])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_vxe_menu, {
                modelValue: selectMenuItem.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => selectMenuItem.value = $event),
                options: adminMenus.value,
                "collapse-fixed": "",
                onClick: handleMenuClick
              }, null, 8, ["modelValue", "options"])])])])]),
              _: 3
            }), _createVNode(_component_vxe_split_pane, null, {
              default: _withCtx(() => [_createVNode(_component_vxe_layout_container, {
                vertical: ""
              }, {
                default: _withCtx(() => [_createVNode(_component_vxe_layout_header, {
                  fixed: ""
                }, {
                  default: _withCtx(() => [_createElementVNode("div", {
                    class: _normalizeClass(['page-header-wrapper', __props.pageHeaderClass])
                  }, [_createElementVNode("div", _hoisted_6, [_renderSlot(_ctx.$slots, "header", {}, () => [_createElementVNode("div", _hoisted_7, _toDisplayString(__props.title), 1)])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("span", _hoisted_9, [_renderSlot(_ctx.$slots, "header-extra")]), _createVNode(_unref(MgAuthorMenu), {
                    id: "sys-author-menu",
                    items: __props.authorMenu,
                    onMenuClick: handleAuthorMenuClick,
                    onAvatarClick: handleAuthorAvatarClick
                  }, {
                    "prefix-panel": _withCtx(({
                      isOpen
                    }) => [_renderSlot(_ctx.$slots, "author-menu-prefix", {
                      isOpen: isOpen
                    })]),
                    "suffix-panel": _withCtx(({
                      isOpen
                    }) => [_renderSlot(_ctx.$slots, "author-menu-suffix", {
                      isOpen: isOpen
                    })]),
                    _: 3
                  }, 8, ["items"])])], 2)]),
                  _: 3
                }), _createVNode(_component_vxe_layout_body, null, {
                  default: _withCtx(() => [_createElementVNode("div", {
                    class: _normalizeClass(['page-body-wrapper', __props.pageClass])
                  }, [_createVNode(_component_vxe_layout_container, {
                    vertical: "",
                    style: {
                      "height": "100%"
                    }
                  }, {
                    default: _withCtx(() => [_createVNode(_component_vxe_layout_header, {
                      fixed: ""
                    }, {
                      default: _withCtx(() => [_createVNode(_unref(MgHistoryRouteTabs), _mergeProps({
                        ref_key: "historyRouteTabsRef",
                        ref: historyRouteTabsRef,
                        "app-group": __props.appGroup,
                        "store-key": __props.historyRouteStoreKey
                      }, historyTabsOptions.value, _toHandlers(historyTabsEventHandlers)), null, 16, ["app-group", "store-key"])]),
                      _: 1
                    }), _createVNode(_component_vxe_layout_body, null, {
                      default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_renderSlot(_ctx.$slots, "content", {}, () => [(_openBlock(), _createBlock(_component_router_view, {
                        key: _unref(route).fullPath
                      }, {
                        default: _withCtx(({
                          Component
                        }) => [(_openBlock(), _createBlock(_KeepAlive, {
                          max: 5,
                          exclude: __props.excludeAlive
                        }, [(_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                          ref_key: "currentPageRef",
                          ref: currentPageRef
                        }, null, 512))], 1032, ["exclude"]))]),
                        _: 1
                      }))])])]),
                      _: 3
                    })]),
                    _: 3
                  })], 2)]),
                  _: 3
                })]),
                _: 3
              })]),
              _: 3
            })]),
            _: 3
          }, 16, ["action-config"])]),
          _: 3
        }), __props.showFooter ? (_openBlock(), _createBlock(_component_vxe_layout_footer, {
          key: 0,
          fixed: ""
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_renderSlot(_ctx.$slots, "footer", {}, () => [_cache[2] || (_cache[2] = _createTextVNode("页脚", -1))])])]),
          _: 3
        })) : _createCommentVNode("", true)]),
        _: 3
      })]);
    };
  }
};